module.exports = __webpack_public_path__ + "static/57gde-11fdcaa046ba0ce094db56dfc166cdce.gif";